'use client'

import { Navigation, Site, trackNavigation } from '@generated/snowplow'
import getSharedContext, { trimPayload } from '../getSharedContext.client'
import { SharedContextEvent } from '../types'
import { getSnowplowDisabledFromCookies } from '@/app/utils/tenant/getSnowplowDisabledFromCookies.client'

type TrackImpressionProps = SharedContextEvent &
  Pick<Site, 'event_type'> &
  Pick<Navigation, 'button_name'>

export default function trackImpression(event: TrackImpressionProps) {
  const snowplowDisabled = getSnowplowDisabledFromCookies()
  if (snowplowDisabled || typeof window === 'undefined') {
    return
  }

  const navigationContext = trimPayload<Navigation>({
    event_type: 'impression',
    button_name: event.button_name,
  })

  const sharedContext = getSharedContext(event)

  trackNavigation({
    ...navigationContext,
    ...sharedContext,
  })
}
